import { useQuery } from "@tanstack/react-query";
import type { License, PaymentCard } from "@shared/schema";

interface CardRenewalsData {
  defaultCard: PaymentCard | null;
  renewals: {
    licenses: License[];
    totalCost: number;
    todayRenewals: License[];
    todayRenewalsCost: number;
  };
}

export function useCardRenewals(days: number = 30) {
  return useQuery<CardRenewalsData>({
    queryKey: ["/api/dashboard/card-renewals", days],
    enabled: true,
  });
}